import { createContext, useContext } from 'react';

import { AggregateEventInfo } from '../../../domain';

export interface SummaryQueryState {
  error?: string;
  isError: boolean;
  isLoading: boolean;
  events: AggregateEventInfo[];
}

export const defaultContext: SummaryQueryState = {
  isError: false,
  isLoading: false,
  events: [],
};

export const SummaryQueryContext = createContext<SummaryQueryState>(defaultContext);

export const useSummaryQueryContext = () => useContext(SummaryQueryContext);
